import {connect} from 'react-redux'
import {fbStateParsed, getSignInFacebookActionCreator} from 'data/redux/actions/authenticationActions';
import FacebookLoginButton from 'gui/components/facebookLoginButton';
import {getInitializationTimeStamp, isLoadingSelector} from 'data/redux/selectors/guiSelector';
import {getPathName, getQueryOrHashParamSelector} from "../../selectors/routerSelector";

const mapStateToProps = (state, ownProps) => {

  return {
    forceChangeTokenKey: getInitializationTimeStamp(state),
    facebookState: fbStateParsed(state),
    access_token: getQueryOrHashParamSelector('access_token')(state),
    loading: isLoadingSelector(state),
    pathname: getPathName(state),
    ...ownProps
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: (formValues) => dispatch(getSignInFacebookActionCreator(formValues)),
  };
};

const FacebookLoginButtonContainer = connect(mapStateToProps, mapDispatchToProps)(FacebookLoginButton);

export default FacebookLoginButtonContainer;
